import { defineMessages } from 'react-intl';

export const giftCardCheckoutLedgerMessages = defineMessages({
  total: {
    defaultMessage: 'Total',
    description: 'Gift Card Checkout Form | Ledger | Total amount title',
  },
});
